import React, { CSSProperties, memo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './headerContent.style';

const HeaderContent = () => {
    const { t } = useTranslation();
    const pageBannerImage = require('../../assets/fleet_product_banner.png');

    return (
        <>
            <p style={styles.pageTitle as CSSProperties}>{t('findFleets.pageTitle')}</p>
            <img src={pageBannerImage} width="100%" />
            <h3 style={styles.subTitle}>{t('findFleets.description')}</h3>
        </>
    );
};

export default memo(HeaderContent);
